import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { RashiChart } from './RashiChart';
import { BirthPlanetChart } from './BirthPlanetChart';
import { BirthCuspalChart } from './BirthCuspalChart';

export function BirthChartTab ({menuArray,birthHouseData,cuspalPositionData,planetaryPositionData,userData,clientData,birthChartType,setBirthChartType}) {
  return(
  <>
    <Collapse in={menuArray[1]} className="m-0 p-0 ">
      <Row id="rashiChartTab" className="m-0 p-0">
          <Col xs={12} lg={4} className="m-0 p-2 pt-0 pagebreakportrait">
            <RashiChart birthHouseData={birthHouseData} userData={userData} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType}/>
          </Col>
          <Col xs={12} lg={4} className="m-0 p-2 pt-0 pagebreakportrait">
            <BirthPlanetChart planetaryPositionData={planetaryPositionData} userData={userData}/>
          </Col>
          <Col xs={12} lg={4} className="m-0 p-2 pt-0">
            <BirthCuspalChart cuspalPositionData={cuspalPositionData} userData={userData}/>
          </Col>
      </Row>
    </Collapse>
  </>  
  );
}